
import { computed, defineComponent } from 'vue';
import { IRastreabilidadeArmamento } from '@/models/Entidades/Estoques/IRastreabilidade';
import SelecionarTipoUsoArma from './SelecionarTipoUsoArma.vue';

export default defineComponent({
  name: 'LancamentoRastreabilidadeArmamento',
  props: {
    rastreabilidadeArmamento: {
      type: Object as () => IRastreabilidadeArmamento,
      required: true,
    },
  },
  components: {
    SelecionarTipoUsoArma,
  },
  emits: ['update:rastreabilidadeArmamento'],
  setup(props, { emit }) {
    const computedRastreabilidadeArmamento = computed({
      get: () => props.rastreabilidadeArmamento,
      set: (valor: IRastreabilidadeArmamento) => {
        emit('update:rastreabilidadeArmamento', valor);
      },
    });

    return {
      props,
      computedRastreabilidadeArmamento,
    };
  },
});
